import React, { useContext, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import { PageTitle } from "../../../_metronic/layout/core";
import { PurchaseEntryForm } from "./PurchaseEntryForm";
import BedRockContext from "../../BedRockContext";

export function PurchaseEntryPage() {
    const { id } = useParams();
    const location = useLocation();
    const myData = useContext(BedRockContext);

    // Check if this is view mode (read-only) based on URL path
    const isViewMode = location.pathname.includes('/view/');
    const isEditMode = Boolean(id) && !isViewMode;
    const pageTitle = isViewMode ? "View Purchase" : (isEditMode ? "Edit Purchase" : "New Purchase Entry");

    // Reset toolbar buttons when entering this page
    useEffect(() => {
        myData.setBaseData({ toolBarButtons: [] });
    }, []);

    const breadcrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
        {
            title: "Purchases",
            path: "/purchases-list",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    return (
        <>
            <PageTitle breadcrumbs={breadcrumbs}>{pageTitle}</PageTitle>
            <PurchaseEntryForm id={id} readOnly={isViewMode} />
        </>
    );
}
